export default function LoadingState({ label = 'Loading' }) {
  return (
    <div className="state-block state-block--loading" role="status" aria-live="polite">
      <div className="spinner" aria-hidden="true" />
      <div className="state-block__text">{label}&hellip;</div>
    </div>
  );
}
